import { render, staticRenderFns } from "./tournamentHero.vue?vue&type=template&id=084765f9&scoped=true&"
import script from "./tournamentHero.vue?vue&type=script&lang=js&"
export * from "./tournamentHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084765f9",
  null
  
)

export default component.exports